import { appendAcuteToxicity } from './appendAcuteToxicity.js';
import { appendLongTermToxicity } from './appendLongTermToxicity.js';
import { appendMiscellaneous } from './appendMiscellaneous.js';
import { appendReactivityAndInstability } from './appendReactivityAndInstability.js';
import { appendVolumeAndFlammability } from './appendVolumeAndFlammability.js';
import { prepareReagents } from './normalize/prepareReagents.js';

export async function calculateSafety(originalReagents, options = {}) {
  const reagents = await prepareReagents(originalReagents, options);
  const scores = {}
  appendAcuteToxicity(reagents, scores, options);
  appendReactivityAndInstability(reagents, scores, options);
  appendVolumeAndFlammability(reagents, scores, options);
  appendLongTermToxicity(reagents, scores, options);
  appendMiscellaneous(reagents, scores, options);

  return { reagents, scores };
}
